import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import HomeRestaurant from '../components/Restaurant/HomeRestaurant';
import * as act from '../actions/OrderSheetsActions';
import {loadTaxonomyAsyncThunk} from '../../ProductsSearch/actions/ProductsSearchActions'
import { RouteComponentProps } from 'react-router';


const mapStateToProps = (state: RootState) => ({
    orderSheets: state.orderSheetsRdc.orderSheets,
    orderSheetsBusy: state.orderSheetsRdc.isBusy,

    taxonomy: state.productsSearchRdc.taxonomy,
    taxonomyLeafs: state.productsSearchRdc.taxonomyLeafs
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        setCurrentOrderSheet: (orderSheetId: number) => {
            dispatch(act.setCurrentOrderSheet(orderSheetId))
        },
        loadTaxonomy: async () => {
            await dispatch(loadTaxonomyAsyncThunk())
        },
        getAllOrderSheets: async () => {
            await dispatch(act.getOrderSheetsAsyncThunk())
        },
    })
}

export type HomeRestaurantProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>

const HomeRestaurantCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeRestaurant);

export default HomeRestaurantCnn